import dateFormatter from './dateFormatter';

export default function getUserLastLoginDate(lastLoginDate) {
  return lastLoginDate ? dateFormatter.format(new Date(lastLoginDate)) : '-';
}
